export const PRIVACY = `**1. Information We Collect**

- **Account information**: Name, email address, phone number, and password when you create an account or log in.
- **Company and customer information you enter**: Company name, phone, address; customer name, phone, email, and address that you type into quotes. You control this data.
- **Quote and usage data**: Quotes you create, line items, search queries for prices or leads, templates used, and coin/plan usage.
- **Payment information**: When you buy a plan or coins, payment details are processed by our payment provider (we do not store full card numbers).
- **Technical data**: IP address, browser type, device information, pages visited, and similar log data collected automatically (including via Cloudflare Insights or similar tools).

We do not require accounts to view the homepage. Lead search and saving/sending quotes require a sign-in.

**2. How We Use Information**

- To provide the quote tool, price searches, lead searches, PDF generation, and account features.
- To process payments and manage subscriptions or coin balances.
- To improve the service, fix problems, and prevent abuse.
- To communicate with you about your account, support requests, or service updates.
- To comply with law or protect rights and safety.

We do not sell your personal information.

**3. Sharing**

We share information only as needed:
- With payment processors to handle charges.
- With hosting and infrastructure providers (such as Cloudflare).
- If required by law, subpoena, or to protect against fraud or harm.
- In connection with a business transfer (merger, sale, etc.), with notice if required.

Customer details you enter stay under your control; we do not use them for our own marketing.

**4. Cookies and Tracking**

We use minimal technical cookies and analytics (Cloudflare Insights or equivalent) for site operation and basic usage statistics. We do not use advertising cookies or sell data to advertisers. You can control cookies through your browser settings.

**5. Data Retention**

We keep account and quote data while your account is active and for a reasonable period afterward for legal, security, and operational reasons. You may request deletion of your account (see Contact).

**6. Your Choices and Rights**

- Access, correct, or delete your account data by contacting us.
- Cancel paid plans anytime (no long-term lock-in).
- Depending on your location (California, other U.S. states, or EU), you may have additional rights regarding personal information. Contact us to exercise them.

**7. Security**

We use reasonable technical and organizational measures to protect information. No method of transmission or storage is 100% secure.

**8. Children**

The service is not directed at children under 13 (or 16 in some jurisdictions). We do not knowingly collect personal information from them.

**9. Changes**

We may update this policy. The new version will be posted here with an updated effective date. Continued use after changes means you accept the updated policy.

**10. Contact**

Email: info@bidmarkquotes.com
Phone: (857) 520-3500`;

export const TERMS = `**1. The Service**

BidMark Quotes helps you create quotes by searching publicly available web prices and generating documents. Features include price searches (low/typical/high with sources), quote templates, PDF downloads, lead search, and optional paid plans with coins. Free users receive limited searches and watermarked sample PDFs. Paid plans unlock additional templates, saving/sending, and higher limits.

Prices returned are drawn from public web sources and are for reference only. They are not guarantees, quotes from specific suppliers, or professional advice. You are solely responsible for the accuracy, legality, and content of any quote you create or send.

**2. Accounts**

You must provide accurate information and keep your login secure. You are responsible for all activity under your account. You may not share accounts or use the service for unlawful purposes.

**3. Plans, Coins, and Payments**

- Free plan: Limited price searches and basic template with sample watermark.
- Paid plans (Starter, Pro, Heavy) and extra coins: Billed monthly or as one-time purchases. Cancel anytime; access continues through the paid period. Unused coins or searches do not roll over unless stated.
- Lead searches use separate coins.
- All fees are non-refundable except where required by law. Prices and features may change with notice.

**4. Acceptable Use**

You agree not to:
- Use the service to create fraudulent, misleading, or illegal quotes.
- Reverse engineer, scrape, or overload the system.
- Upload content you do not have rights to.
- Violate any laws or third-party rights.

**5. Intellectual Property**

We own the site, software, templates, and branding. You retain ownership of the content and data you enter (company info, customer details, line items). You grant us a limited license to process that data solely to provide the service.

**6. Disclaimers**

The service is provided “as is.” We do not warrant that price data is complete, current, or accurate, or that the service will be uninterrupted or error-free. You assume all risk for relying on generated quotes.

**7. Limitation of Liability**

To the fullest extent permitted by law, BidMark Quotes is not liable for any indirect, incidental, special, or consequential damages, or for lost profits, arising from your use of the service or any quote. Our total liability is limited to the amount you paid us in the prior 12 months (or $100 if free).

**8. Termination**

You may stop using the service at any time. We may suspend or terminate accounts for violations of these Terms or for operational reasons. Upon termination, your right to use the service ends.

**9. Governing Law**

These Terms are governed by the laws of the Commonwealth of Massachusetts, without regard to conflict-of-law rules.

**10. Changes**

We may update these Terms. Continued use after the updated Terms are posted constitutes acceptance.

**11. Contact**

Email: info@bidmarkquotes.com
Phone: (857) 520-3500

© 2026 BidMark Quotes. All rights reserved.`;
